import React from 'react';

import { MediaButton } from '../media-button';
import RotatableGallery from '../three-sixty/rotatable-gallery';
import { getProportionUrl, getStyle } from './helper';

const onMediaClick = (e: React.MouseEvent<HTMLButtonElement>, func: () => void) => {
  e.stopPropagation();
  e.preventDefault();
  func();
};

interface ThreeSixtyPreviewRotationProps {
  urls: {
    webp?: string | undefined;
    url: string;
  }[];
  imageAlt?: string;
  proportions: number;
}

const ThreeSixtyPreviewRotation = ({
  urls,
  imageAlt,
  proportions,
}: ThreeSixtyPreviewRotationProps) => (
  <div className="slick-slide-image-container" style={getStyle(proportions)}>
    <div className="slick-slide-image">
      <RotatableGallery images={urls} imageAlt={imageAlt} fullscreen={false} />
    </div>
  </div>
);

interface ImageProps {
  image: {
    webp?: string | undefined;
    url: string;
  };
  proportions: number;
  onDisableNavigation: () => void;
}

const Image = ({ image, proportions, onDisableNavigation }: ImageProps) => (
  <div className="slick-slide-item">
    <div className="slick-slide-image-container" style={getStyle(proportions)}>
      <picture>
        {image.webp && <source type="image/webp" srcSet={image.webp} />}
        <img
          src={getProportionUrl(image.url, proportions)}
          alt="förhandsvisning av exteriör 360"
          className="slick-slide-image"
        />
      </picture>
      <MediaButton
        text="Starta 360° exteriört"
        onClick={(e) => onMediaClick(e, onDisableNavigation)}
        icon="360"
      />
    </div>
  </div>
);

interface ThreeSixtyPreviewProps {
  urls: {
    webp?: string | undefined;
    url: string;
  }[];
  visible?: boolean;
  proportions: number;
  imageAlt?: string;
  navigationDisabled: boolean;
  onDisableNavigation: () => void;
}

const ThreeSixtyPreview = ({
  urls,
  visible,
  proportions,
  imageAlt,
  navigationDisabled,
  onDisableNavigation,
}: ThreeSixtyPreviewProps) => (
  <div
    className="slick-slide-item"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    {navigationDisabled && visible && (
      <ThreeSixtyPreviewRotation urls={urls} proportions={proportions} imageAlt={imageAlt} />
    )}
    {(!visible || (!navigationDisabled && visible)) && (
      <Image image={urls[0]} proportions={proportions} onDisableNavigation={onDisableNavigation} />
    )}
  </div>
);

export default ThreeSixtyPreview;
